// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'

export let DirectOrderStatusChangedMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_ORDER_STATUS_CHANGED_MESSAGE)
    this.orderId = ''
    this.statusOrder = -1
}

DirectOrderStatusChangedMessage.prototype = Object.create(DirectMessageBase.prototype)

Object.defineProperty(DirectOrderStatusChangedMessage.prototype, 'OrderId', {
    get: function () { return this.orderId },
    set: function (val) { this.orderId = val }
})

Object.defineProperty(DirectOrderStatusChangedMessage.prototype, 'StatusOrder', {
    get: function () { return this.statusOrder },
    set: function (val) { this.statusOrder = val }
})